export { default } from './FooterView';



// WEBPACK FOOTER //
// ./src/components/FooterView/index.js